module.exports = __webpack_public_path__ + "static/media/user-chart.8c83ef5a.svg";